// extracted by mini-css-extract-plugin
export default {"ToggleFullscreenButton":"yKKSL","buttonPositioning":"r7hNP","buttonAspect":"ulBMU"};